import { render, staticRenderFns } from "./ViewerImageMap.vue?vue&type=template&id=437c64e0"
import script from "./ViewerImageMap.vue?vue&type=script&lang=js"
export * from "./ViewerImageMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports